import NotFound from 'core/NotFound/NotFound';
export default NotFound;
